import Vue from 'vue'
import VueRouter from 'vue-router'
import app from './app.js'
import store from './store/index'
import Canvases from './components/Canvases'
import Dashboard from './components/admin/Dashboard'
import Import from './components/admin/Import'
import ManifestExplorer from './components/explorer/ManifestExplorer'

Vue.use(VueRouter)

const router = new VueRouter({
	mode: 'history',
	routes: [
		{
			name: 'canvases',
			path: '/coll/:cId/manif/:mId',
			component: Canvases,
			props: {
				displayHeader: true
			}
		}, {
			name: 'dashboard',
			path: '/dashboard',
			component: Dashboard
		}, {
			name: 'import',
			path: '/import',
			component: Import
		}, {
			name: 'all-documents',
			path: '/all-documents',
			component: ManifestExplorer,
			props: {
				allDocuments: true,
			}
		}, {
			name: 'my-documents',
			path: '/my-documents',
			component: ManifestExplorer,
			props: {
				allDocuments: false,
			}
		}
	]
})

export default router